module.exports = __webpack_public_path__ + "static/media/binnen_woonkamer_haard.35800b1d.jpg";